(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        $('body').on('click', '.load-more:not(.disabled)', function () {
            var that = $(this);

            that.addClass('disabled');

            var uri = that.data('uri');
            var target = that.data('bs-target');
            var targetElement = $(target);

            $.get({
                url: uri,
                success: function (data) {
                    targetElement.append(data);
                    that.remove();
                }
            });

            return true;
        });

    });
})(jQuery, window, document, window.PageLoadedQueue);
